<template>
  <div>
    <p class="cm-mg-p-wzd">2. {{ $t('common_words.varieties') }}</p>
    <hr />
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <div
          style="margin-top: 12px"
          class="form-group has-label pb-1 pt-3 sticky-button-without-mx"
        >
          <minus-plus
            :label="`${$t('common_words.variety_number')}: *`"
            @handlePlus="handlePlus"
            @handleMinus="handleMinus"
            :value="model.varieties_number"
          />
        </div>
      </div>
      <div class="col-8">
        <span v-for="index in model.varieties_number" :key="index">
          <div class="row">
            <div class="col-8">
              <fg-input
                class="required-fourth-step"
                v-model="model.variety_names[index - 1]"
                type="text"
                :label="`${$t('common_words.variety_name')}: *`"
                :placeholder="$t('common_words.williams')"
                name="common_words.variety_name"
                v-validate="modelValidations.variety_name"
                :error="
                  getError('common_words.variety_name', true, {
                    '%1%': index,
                  })
                "
              ></fg-input>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        varieties_id: [],
        varieties_number: 1,
        variety_names: [],
      },
      modelValidations: {
        variety_name: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinValidations],
  methods: {
    handlePlus() {
      this.model.varieties_number++;
    },
    handleMinus() {
      if (this.model.varieties_number > 1) {
        this.model.varieties_number--;
      }
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', this.model);
        return res;
      });
    },
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const { crop_varieties } = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.varieties_number = crop_varieties.length;
      crop_varieties.forEach(({ id, name }) => {
        this.model.varieties_id.push(id);
        this.model.variety_names.push(name);
      });
    }
  },
};
</script>
<style></style>
